import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar35Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar35 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar35Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar35" clipPath="url(#clip0_2286_5339)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M223.254 142.245c0-50.03.159-94.708-42.233-94.708-76.534 0-82.889 31.45-82.889 81.488 0 1.911.08 3.822.215 5.734-.82.087-1.688.278-2.596.597-5.647 1.983-6.587 13.571-2.087 25.891 4.5 12.32 12.727 20.698 18.373 18.715.167-.064.335-.127.502-.207-.08 6.021-.359 20.675-1.203 27.532-1.075 8.752-4.651 22.291-4.651 22.291s42.695 37.725 73.221 34.914c12.79.04 11.492-12.408 11.492-12.408s-1.656-10.289-.478-16.485c.223-1.163.574-2.533 1.004-3.99 18.428-5.408 21.853-27.508 30.43-58.958 2.119-13.953.892-13.905.892-30.422l.008.016Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M175.128 140.245c-9.151-12.216-28.097-3.679-31.697-.151-.502.486-.605 1.426-.239 2.095.223.398.558.613.9.613a.954.954 0 0 0 .661-.287c.956-.94 3.21-2.301 6.117-3.456-.008.135-.024.263-.024.406 0 3.6 2.978 6.523 6.658 6.523 3.679 0 6.657-2.923 6.657-6.523 0-.884-.183-1.728-.517-2.501 3.743.406 7.303 1.944 9.891 5.4.438.581 1.147.581 1.585 0 .438-.581.438-1.529 0-2.119h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M135.89 132.059s11.683-2.174 21.614-2.174c7.048 0 15.864 1.704 19.153 2.039a2.341 2.341 0 0 0 2.103-.884l1.831-2.326c1.004-1.274.407-3.13-1.162-3.607-4.97-1.521-14.67-4.954-21.336-4.42-9.557.764-16.358 1.131-22.203 11.372Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M198.685 130.553c-.111.9.701 1.641 1.609 1.49 3.663-.606 10.241-1.633 14.208-1.522 4.682.136 11.476.892 11.476.892s.884-6.88-.749-8.011c-1.633-1.131-7.335-1.195-11.747-1.195s-7.199.932-9.573 1.927c-3.703 1.553-4.969 4.277-5.232 6.419h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M177.891 227.675a11.939 11.939 0 0 1-.533-.04c-.39-.024-.773-.048-1.163-.08-.207-.016-.414-.048-.621-.071-.366-.04-.725-.072-1.091-.128l-.645-.095c-.359-.056-.725-.104-1.083-.168-.215-.04-.43-.087-.645-.127-.367-.072-.733-.136-1.099-.215a18.426 18.426 0 0 1-.638-.152 57.076 57.076 0 0 1-1.122-.27c-.2-.048-.399-.112-.606-.168-.39-.103-.772-.207-1.162-.326-.192-.056-.375-.119-.566-.175-.406-.128-.804-.247-1.21-.383-.176-.055-.351-.119-.526-.183-.422-.143-.836-.294-1.258-.446-.16-.055-.319-.119-.478-.183-.438-.167-.876-.334-1.314-.51a8.395 8.395 0 0 1-.43-.183c-.454-.191-.916-.382-1.37-.589-.128-.056-.247-.112-.374-.167-.478-.215-.956-.438-1.434-.661-.103-.048-.207-.104-.311-.152a37.646 37.646 0 0 1-1.489-.748c-.087-.048-.175-.088-.255-.136-.517-.27-1.035-.549-1.553-.828-.063-.032-.127-.072-.191-.103-.541-.303-1.083-.606-1.624-.924-.04-.024-.072-.048-.112-.064-.565-.334-1.131-.677-1.704-1.027-.016-.008-.024-.016-.04-.024-9.517-5.909-18.803-14.304-26.894-24.243 5.447 15.196 21.853 49.616 62.549 66.309a8.96 8.96 0 0 0 1.983.565c3.09-3.671 2.556-8.888 2.556-8.888s-1.656-10.289-.478-16.485c.59-3.074 2.095-7.598 3.465-11.373-3.958 2.27-8.777 3.48-14.821 3.48-.558 0-1.123-.015-1.689-.039h-.024Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M203.017 125.887c-.565-.103-1.441.135-2.755.908-5.981 3.528-6.539 13.969-6.387 17.369.151 3.409 9.899 24.02 4.229 28.742-1.768 1.466-7.757-2.293-9.764-2.293-11.827-.024-8.848 3.313-7.064 3.544 1.776.231 14.16 3.273 16.429 3.058 2.278-.215 6.308-1.521 6.674-5.654.367-4.134-5.694-22.324-6.363-25.812-.151-.78 1.497-2.19 2.469-2.978 1.736-2.095 3.48-6.18 9.724-6.18 7.128 0 13.045 5.646 13.045 5.646V129.63l-20.237-3.751v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_6"
          d="M223.079 140.326c-2.652-3.242-16.589-11.054-23.326.135-.319.534-.319 1.402 0 1.935.318.534.844.534 1.162 0a11.32 11.32 0 0 1 2.246-2.707c.048 3.352 2.835 6.06 6.276 6.06 3.44 0 6.275-2.755 6.275-6.156a6.08 6.08 0 0 0-.103-1.091c3.066 1.155 5.575 2.915 6.483 4.03.151.183.318.263.485.263.255 0 .502-.192.669-.558.271-.613.191-1.465-.175-1.919l.008.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M191.406 252.092s1.29 12.448-11.492 12.408c-30.518 2.811-73.213-34.906-73.221-34.914L48.23 262.812c27.133 25.341 63.552 40.855 103.603 40.855 32.286 0 62.207-10.082 86.815-27.261L191.414 252.1l-.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M192.401 207.032c-.501 0-1.027-.024-1.56-.088-4.811-.525-9.223-1.951-9.334-2.014a1.194 1.194 0 1 1 1.131-2.103c.024.008 4.149 1.266 8.457 1.736 4.134.454 9.087-2.094 9.119-2.11a1.205 1.205 0 0 1 1.649.374c.35.558.183 1.29-.375 1.641-.135.087-4.913 2.548-9.094 2.548l.007.016Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <G id="hair" fill={c.hair}>
          <Path
            id="hair_2"
            d="M196.79 177.247c-3.01 0-10.536-.582-13.953-.908-9.079 1.25-21.089 4.157-24.752 10.895-6.124 11.277-6.419 33.568-6.419 33.568s16.82 20.65 41.516 18.102c24.697-2.549 21.909-24.195 21.726-26.926-.183-2.732 2.971-23.653 2.971-23.653s-5.185-9.008-16.629-11.978a11.292 11.292 0 0 1-3.377.86c-.255.024-.621.04-1.075.04h-.008Zm12.288 15.02c0 .836 3.696 16.971-4.109 20.794-6.769 3.313-7.606-2.119-7.43-6.029-1.53 1.075-3.879 2.007-7.447 2.007s-5.774-.924-7.143-2.039v1.951c0 4.014 1.353 7.757-3.863 7.94-5.216.184-14.869-11.229-15.299-17.441-.223-3.281-5.216-12.726 26.003-11.93 17.393.438 19.288 2.883 19.288 4.747Z"
          />
          <Path
            id="hair_3"
            d="M229.084 77.577s4.134-10.433 3.337-13.323c-.796-2.891-6.14-2.517-6.14-2.517l-4.5-3.13s1.498-10.727-3.464-11.19c-4.954-.461-9.756.71-9.756.71s.319-6.873-6.052-7.391c-6.38-.526-8.203.916-8.203.916s-.494-6.14-6.921-5.917c-6.419.223-9.366 2.572-9.366 2.572s-1.847-1.999-4.754-1.999c-2.907 0-6.045 1.513-6.045 1.513s-1.417-3.026-6.586-2.89c-5.169.135-9.023 4.069-9.023 4.069s-5.328-4.309-10.616-1.808c-5.296 2.5-5.32 5.256-5.32 5.256s-8.251-3.09-13.69.47c-5.44 3.56-5.488 7.654-5.488 7.654s-2.596.923-5.742 1.752c-3.145.828-7.183.294-9.716 2.994-2.524 2.708-2.906 9.947-5.606 12.113-2.7 2.166-9.04-1.02-11.357 7.845-2.31 8.864 1.426 9.517.733 14.176-.701 4.659-3.87 4.682-3.711 7.9.159 3.217 4.42 2.508 4.42 4.993 0 2.485-2.533 2.62-.064 4.651 2.477 2.031 3.09 4.635 2.7 6.276-.39 1.632-1.521 3.807-.152 5.256.964 1.02 5.058 11.086 7.407 16.987.111-.047.23-.103.342-.143 6.937-2.437 11.198 2.222 14.758 9.78a126.817 126.817 0 0 1 5.359 5.033l7.248-4.301s-.892-11.723-.757-19.336c.143-7.614 12.91-12.225 12.91-12.225l-6.356-21.503a47.154 47.154 0 0 1 6.65-2.986c30.789-11.078 45.984-6.538 61.387-6.077 25.867.78 25.532 34.54 25.532 34.54s3.56-9.7 2.851-14.343c-.709-4.635-.74-5.192-.74-5.192l2.795-7.542-.852-3.082s6.53-4.046 5.344-7.017c-1.187-2.97-2.796-3.528-2.796-3.528v-.016Z"
          />
        </G>
        <Path
          id="Vector_9"
          d="M209.946 190.14s-8.84 1.704-18.699 1.163c-10.911-.597-22.944-3.401-22.944-2.15 0 2.381 16.78 9.795 22.578 9.795 7.597 0 19.392-7.804 19.057-8.816l.008.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5339">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
